<template>
	<sub-dialog ref="ossDialog" title="图片空间" width="800" @resolve="resolve">
		<div class="flex-column" style="height: 600px; padding: 0">
			<div class="flex-grow flex">
				<div class="oss-aside">
					<menu-tree ref="tree" default-current :leading="false" @node-click="loadFiles"></menu-tree>
				</div>
				<div class="flex-grow flex-column">
					<div class="oss-handle flex-between-center">
						<div class="flex-center">
							<dl class="sort">
								<dt class="flex-center">
									<label>排序:</label>
									<div class="item flex-center">
										<span>{{currentSort.name}}</span>
										<i class="sf" :class="{'sf-sort-up': currentSort.type == 'DESC', 'sf-sort-down': currentSort.type == 'ASC'}"></i>
									</div>
								</dt>
								<dd>
									<div v-for="(item, i) in sortOptions" :key="i" class="item flex-center" @click="currentSort = item">
										<span>{{item.name}}</span>
										<i class="sf" :class="{'sf-sort-down': item.type == 'DESC', 'sf-sort-up': item.type == 'ASC'}"></i>
									</div>
								</dd>
							</dl>
							
							<div class="search flex-center">
								<input v-model="fileKeyword" class="flex-grow" placeholder="搜索文件名、标签关键词" @keydown.enter="fileSearchHandle()">
								<i class="sf sf-search" @click="fileSearchHandle()"></i>
							</div>
							
							<sub-checkbox class="filter" :checked="filterState" @change="e => filterState = e">仅显示可选</sub-checkbox>
							
							<a class="refresh flex-center" @click="refreshHandle()"><i class="sf sf-refresh"></i>刷新</a>
						</div>
						
						<button class="upload" @click="uploadHandle" v-if="userType!=0"><i class="sf sf-upload"></i>上传文件</button>
					</div>
					<div class="oss-main flex-grow">
						<empty v-if="filterFilesList && filterFilesList.length == 0"></empty>
						<div v-else-if="filterFilesList" class="file-list flex-wrap">
							<div v-for="(item, i) in filterFilesList" :key="item.id" class="file-item" :class="{'z-crt': currentFiles.find(temp => temp.id == item.id)}" :title="`${item.filename}${item.fileType == 1 ? ` (${item.width}×${item.height})` : ''}`" @click="clickHandle(item)">
								<sub-image class="image" :src="(item.fileType == 1 ? item.path : fileIcon[item.fileType]) || require('@/submodule/assets/image/oss/file.png')"></sub-image>
								<p class="ellipsis">{{item.filename}}</p>
								<a class="preview flex-center" title="预览" @click.stop="sub.$preview({src: item.path})"><i class="sf sf-search"></i></a>
								<span class="flex-center"><i class="sf sf-check"></i></span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<dl v-if="multiple" class="oss-selected">
				<dt>已选列表</dt>
				<dd>
					<draw-sort v-model="currentFiles" ref="fileSort" class="file-list flex">
						<template v-slot="{list}">
							<draw-item v-for="({item}, i) in list" :key="item.id" :index="i">
								<div class="file-item">
									<sub-image class="image" :src="(item.fileType == 1 ? item.path : fileIcon[item.fileType]) || require('@/submodule/assets/image/oss/file.png')"></sub-image>
									<p class="ellipsis">{{item.filename}}</p>
									<a class="remove flex-center" @mousedown.stop @click.stop="clickHandle(item)"><i class="sf sf-cross"></i></a>
								</div>
							</draw-item>
						</template>
					</draw-sort>
				</dd>
			</dl>	
		</div>
	</sub-dialog>
</template>

<script>
	import menuTree from './components/menu_tree.vue'
	import drawSort from '@/submodule/components/draw_sort/index.vue'
	import drawItem from '@/submodule/components/draw_sort/item.vue'
	import empty from '@/submodule/components/public/empty.vue'
	
	var numberOfType = {
		image: 1,
		video: 3
	}
	
	var nameOfType = {
		image: '图片',
		video: '视频'
	}
	
	export default {
		components: {
			menuTree,
			drawSort,
			drawItem,
			empty
		},
		
		data() {
			let sortOptions = [{
				name: '名称',
				type: 'DESC',
				value: 'file_name'
			}, {
				name: '名称',
				type: 'ASC',
				value: 'file_name'
			}, {
				name: '时间',
				type: 'DESC',
				value: 'create_date'
			}, {
				name: '时间',
				type: 'ASC',
				value: 'create_date'
			}];
			
			return {
				selectConfig: {},
				multiple: false,
				fileKeyword: '',
				fileSearchState: false,
				filterState: true,
				
				currentNode: false,
				
				filesList: '',
				fileIcon: {
					2: require('./static/folder.png'),
					3: require('./static/video.png')
				},
				currentFiles: [],
				
				sortOptions,
				currentSort: sortOptions[0]
			}
		},
		
		computed: {
			filterFilesList() {
				if (this.filterState && this.filesList) {
					return this.filesList.filter(item => {
						if (this.selectConfig.type && numberOfType[this.selectConfig.type] != item.fileType) {
							return false;
						}
						
						if (this.selectConfig.size) {
							let size = this.selectConfig.size.split(',');
							if (size[1] == 0) {
								if (size[0] != item.width) {
									return false;
								}
							} else if (size[0] == 0) {
								if (size[1] != item.height) {
									return false;
								}
							} else if (size[0] != item.width || size[1] != item.height) {
								return false;
							}
						}
						
						return true;
					});
				} else {
					return this.filesList;
				}
			},
            userType(){
                var result = 1;
                if (this.currentNode && this.currentNode.data && (this.currentNode.data.id == -1 || this.currentNode.data.user_type == 0)) {
                    result = 0;
                }
                return result;
            }
		},
		
		watch: {
			filesList() {
				if (this.selectConfig && this.selectConfig.count == 1) {
					this.currentFiles = [];
				}
			},
			
			currentSort() {
				this.refreshHandle();
			}
		},
		
		methods: {
			init() {
				if (!this._initialized) {
					this._initialized = true;
					this.$refs.tree.init();
				}
			},
			
			config(config) {
				this.init();
				this.filterState = true;
				this.currentFiles = [];
				this.selectConfig = config;
				this.multiple = config.count > 1;
				this.$refs.ossDialog.open();
			},
			
			loadFiles(node = this.currentNode, id) {
				this.fileKeyword = '';
				if (node) {
					this.fileSearchState = false;
					this.currentNode = node;
					node.expand();
				}
				this.request({
					url: '/oss/file/directory_contents',
					data: Object.assign({
						directory_id: node ? node.data.id : id
					}, {
						file_sort_keyword: this.currentSort.value,
						file_sort_type: this.currentSort.type
					}),
					success: data => {
						this.filesList = data.filter(item => item.fileType != 2);
					}
				});
			},
			
			fileSearchHandle(last) {
				if (!this.fileKeyword.trim() && !last) {
					this.sub.$message({
						text: '请输入搜索内容'
					})
					return;
				}
				
				this._lastSearchKeyword = last || this.fileKeyword.trim();
				this.request({
					url: '/oss/file/search',
					data: Object.assign({
						keyword: last || this.fileKeyword.trim()
					}, {
						file_sort_keyword: this.currentSort.value,
						file_sort_type: this.currentSort.type
					}),
					success: data => {
						this.currentNode = false;
						this.$refs.tree.selectNode();
						this.fileSearchState = true;
						this.filesList = data ? data.filter(item => item.fileType != 2) : [];
					}
				});
			},
			
			clickHandle(item) {
				let index = this.currentFiles.findIndex(temp => temp.id == item.id);
				if (index != -1) {
					this.currentFiles.splice(index, 1);
				} else {
					if (this.selectConfig.type && numberOfType[this.selectConfig.type] != item.fileType) {
						this.sub.$message({
							text: `请选择类型为${nameOfType[this.selectConfig.type]}的文件`
						});
						return;
					}
					
					if (this.selectConfig.size) {
						let size = this.selectConfig.size.split(',');
						if (size[1] == 0) {
							if (size[0] != item.width) {
								this.sub.$message({
									text: `请选择宽度为${size[0]}的文件`
								});
								return;
							}
						} else if (size[0] == 0) {
							if (size[1] != item.height) {
								this.sub.$message({
									text: `请选择高度为${size[1]}的文件`
								});
								return;
							}
						} else if (size[0] != item.width || size[1] != item.height) {
							this.sub.$message({
								text: `请选择尺寸为${size.join('x')}的文件`
							});
							return;
						}
					}
					
					if (this.selectConfig.count == 1) {
						this.currentFiles = [item];
					} else {
						if (this.currentFiles.length >= this.selectConfig.count) {
							this.sub.$message({
								text: `最多只能选择${this.selectConfig.count}个文件`
							});
							return;
						}
						this.currentFiles.push(item);
					}
				}
			},
			
			uploadHandle() {
				if (this.currentNode && this.currentNode.data && (this.currentNode.data.id == -1 || this.currentNode.data.user_type == 0)) {
					this.sub.$message({
						text: '无法在【共享素材】目录中上传文件'
					});
					return;
				}
				if (this.fileSearchState) {
					this.sub.$message({
						text: '无法在全部搜索结果中上传文件'
					});
					return;
				}

				this.sub.$upload({
					multiple: true,
					success: data => {
						Promise.all(Array.from(data, item => {
							return new Promise(resolve => {
								new Promise(res => {
									if (item.fileObj.type.includes('image')) {
										let info = this.sub.parseFile(item.filePath);
										let img = new Image();
										img.onload = function() {
											res(img);
										}
										img.src = item.filePath.replaceAll(info.name, encodeURIComponent(info.name));
									} else {
										res();
									}
								}).then(data => {
									this.request({
										url: '/oss/file/save',
										data: {
											directory_id: this.currentNode.data.id,
											file_real_name: item.fileName,
											file_path: item.filePath,
											file_name: item.fileObj.name,
											file_size: item.fileObj.size,
											file_model: item.fileObj.name.substring(item.fileObj.name.lastIndexOf('.') + 1),
											width: data && data.width,
											height: data && data.height
										},
										success: resolve
									});
								})
							})
						})).then(() => {
							this.refreshHandle();
						});
					}
				});
			},
			
			refreshHandle() {
				this.filesList = '';
				this.fileSearchState ? this.fileSearchHandle(this._lastSearchKeyword) : this.loadFiles();
			},
			
			resolve(stop, next) {
				stop();
				if (!this.currentFiles.length) {
					this.sub.$message({
						text: '请选择文件'
					});
					return;
				}
				if (this.selectConfig.success) {
					this.selectConfig.success(this.currentFiles);
				} else {
					this.selectConfig.resolve(this.selectConfig.count == 1 ? this.currentFiles[0].path : Array.from(this.currentFiles, item => item.path));
				}
				next();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.oss {
		&-aside {
			box-sizing: border-box;
			width: 200px;
			border-right: 1px solid #ddd;
		}
		
		&-handle {
			height: 48px;
			border-bottom: 1px solid #ddd;
			padding: 0 10px;
			
			.sort {
				z-index: 9;
				position: relative;
				font-size: 12px;
				
				&:hover {
					dd {
						display: block;
					}
				}
				
				dt {
					height: 24px;
					border: 1px solid #ccc;
					padding-left: 6px;
					background: #fff;
					cursor: pointer;
				}
				
				dd {
					display: none;
					position: absolute;
					right: 0;
					top: 25px;
					border: 1px solid #ccc;
					background: #fff;
					
					.item:hover {
						background: #eee;
					}
				}
				
				.item {
					width: 50px;
					height: 24px;
					cursor: pointer;
					
					.sf {
						margin-left: 4px;
					}
				}
			}
			
			.search {
				width: 170px;
				height: 24px;
				border: 1px solid #ccc;
				margin-left: 10px;
				background: #fff;
				
				input {
					height: 100%;
					padding-left: 8px;
					font-size: 12px;
				}
				
				.sf {
					width: 26px;
					line-height: 24px;
					font-size: 12px;
					text-align: center;
					color: #999;
					cursor: pointer;
				}
			}
			
			.filter {
				margin-left: 10px;
			}
			
			.refresh {
				height: 20px;
				margin-left: 10px;
				font-size: 13px;
				color: #008BED;
				
				.sf {
					margin-right: 5px;
				}
			}
			
			.upload {
				width: 102px;
				height: 30px;
				border: 1px solid #ccc;
				font-size: 14px;
				background: #fff;
				
				&:hover {
					border-color: #666;
				}
				
				.sf {
					margin-right: 5px;
					font-size: 16px;
				}
			}
		}
		
		&-main {
			overflow: auto;
			background: #F6F6F6;
		}
		
		&-selected {
			dt {
				padding: 0 10px;
				line-height: 28px;
				font-size: 13px;
				font-weight: bold;
				color: #333;
				background: #eee;
			}
			
			dd {
				min-height: 106px;
				overflow-x: auto;
				overflow-y: hidden;
				
				.file-list {
					float: left;
				}
			}
		}
	}
	
	.file {
		&-list {
			padding: 0 10px 10px 0;
		}
			
		&-item {
			position: relative;
			box-sizing: border-box;
			width: 85px;
			height: 85px;
			border: 1px solid #bbb;
			margin-left: 10px;
			margin-top: 10px;
			cursor: pointer;
			user-select: none;
			
			&:hover {
				border-color: #999;
				
				.preview {
					display: flex;
				}
			}
			
			&.z-crt {
				span {
					display: flex;
				}
			}
			
			p {
				position: absolute;
				left: 0;
				right: 0;
				bottom: 0;
				padding: 0 5px;
				line-height: 18px;
				font-size: 12px;
				text-align: center;
				color: #fff;
				background: rgba(0,0,0,.6);
			}
			
			span {
				display: none;
				position: absolute;
				right: 1px;
				top: 1px;
				width: 16px;
				height: 16px;
				border-radius: 100%;
				font-size: 12px;
				color: #fff;
				background: #3FC60A;
			}
			
			.preview {
				display: none;
				position: absolute;
				left: -1px;
				top: -1px;
				width: 24px;
				height: 24px;
				font-size: 12px;
				color: #fff;
				background: rgba(0,0,0,.6);
			}
			
			.remove {
				position: absolute;
				right: -1px;
				top: -1px;
				width: 18px;
				height: 18px;
				font-size: 12px;
				color: #fff;
				background: #f55;
			}
		}
	}
</style>